/**
 * Mixin for virtual scrolling functionality.
 */
export default {
    data() {
        return {
            scrollTop: 0,
            containerHeight: 0
        };
    },

    methods: {
        handleScroll() {
            if (!this.$refs.scrollContainer) return;
            this.scrollTop = this.$refs.scrollContainer.scrollTop;
        },

        updateContainerHeight() {
            if (!this.$refs.scrollContainer) return;
            const newHeight = this.$refs.scrollContainer.clientHeight;
            if (newHeight !== this.containerHeight && newHeight > 0) {
                this.containerHeight = newHeight;
            }
        },

        scrollToTop() {
            if (!this.$refs.scrollContainer) return;
            this.$refs.scrollContainer.scrollTop = 0;
            this.scrollTop = 0;
        }
    }
};
